import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../../../PanelPage";
import {iFrameMerchantService} from "../../../../../services/IframeMerchantService";
import {Messages} from "../../../../../Messages";
import {Link} from "../../../../../../stem-core/src/ui/UIPrimitives";
import {MerchantButton} from "../../../../../common/MerchantButton";
import {Flow} from "../../../../initializeFlows";
import {Router} from "../../../../../../stem-core/src/ui/Router";
import {MessageElement} from "../../../../../widget/ui/MessageElement";
import {INLINE_EDIT_DONATION_URLS} from "../../../../PanelConstants.js";


export class CancelDonationPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.donatePageCancelDonationTitle,
            onAction: () => Router.changeURL(INLINE_EDIT_DONATION_URLS.cancelSuccess),
            onBack: () => Router.back(),
        };
    }

    render() {
        const {styleSheet} = this;
        const {onAction, onBack} = this.options;
        const merchantName = iFrameMerchantService.getMerchant().name;

        return [
            <MessageElement message={Messages.donatePageCancelDonationText1(merchantName)}/>,
            <MessageElement message={Messages.donatePageCancelDonationText2(merchantName)}/>,
            <MerchantButton onClick={() => Flow.donation.cancel(onAction)}
                            className={styleSheet.actionButton}>
                {Messages.donatePageCancelDonationButton}
            </MerchantButton>,
            <Link value={Messages.takeMeBack}
                  className={styleSheet.backButton}
                  onClick={onBack}
            />
        ];
    }
}
